import React from 'react';
//import gifImage from "../../assets/videos/animation.gif";
import gifImage from '../../assets/videos/cubicaje/presentacionM_mameluco.gif';
import gifImageWoman from '../../assets/videos/cubicaje/presentacionF_mameluco.gif';
import { useAvatar } from '../../hooks/useAvatar';

// import { BlobServiceClient } from '@azure/storage-blob';

// const azureStorageConfig = {
//   accountName: 'interconectarblob',
//   accountKey: 'GGQB0VbdMfwT3+hKjD6vdT+s6oVfx+foJ7PaU+kWNfFVWSPVpPAxEzzMB391hVuCSXB1ZtO2bXo8+AStbpsC+Q==',
//   containerName: 'test-exportador',
// };

// const blobServiceClient = BlobServiceClient.fromConnectionString(
//   `DefaultEndpointsProtocol=https;AccountName=${azureStorageConfig.accountName};AccountKey=${azureStorageConfig.accountKey};EndpointSuffix=core.windows.net`
// );

// const containerClient = blobServiceClient.getContainerClient(azureStorageConfig.containerName);

// async function listBlobs() {
//   let blobNames: string[] = [];

//   for await (const blob of containerClient.listBlobsFlat()) {
//     blobNames.push(blob.name);
//   }

//   return blobNames;
// }

// listBlobs().then((blobNames) => {
// }).catch((error) => {
//   console.error('Error al listar blobs:', error);
// });

interface Props {
	showSrcImage: boolean;
	urlImagen: string | null;
}

const VideoAnimation: React.FC<Props> = ({ showSrcImage, urlImagen }) => {
	const srcParameter = urlImagen !== null ? urlImagen : gifImage;

	const avatar = useAvatar();

	// Si srcParameter es igual a gifImage y avatar es 'women', cambiar srcParameter a gifImageWoman
	const resolvedSrc = srcParameter === gifImage && avatar === 'women' ? gifImageWoman : srcParameter;
	return (
		<img
			src={showSrcImage ? resolvedSrc : srcParameter}
			alt="Animación GIF"
			style={{ maxWidth: '100%', height: 'auto' }}
		/>
	);
};

export default VideoAnimation;
